import React from "react";
import {useSubheader} from "../../_metronic/layout";

export const FAQPage = () => {
	const suhbeader = useSubheader();
	suhbeader.setTitle("راهنما");
  return (
		<>
		</>
	);
};
